import { defineStore } from 'pinia';

import { container } from '@/container';
import { Logger } from '@/services/Logger';
import { ProQaCaseReqMsg, ProQaRunStatusReqMsg } from '@/services/signalr/MessageTypes/ProQa';
import { Signalr } from '@/services/signalr/Signalr';
import { IToast } from '@/services/toaster/types';
import { ITrip } from '~/api/ITrip';

export const useStore = defineStore('proQa', {
  state: () => ({
    isProQaConnected: false,
    workstation: '',
    errorToast: <IToast | undefined> undefined,
  }),
  getters: {
    getWorkstation: (state) => () => state.workstation,
  },
  actions: {
    async registerProQaCase(trip: ITrip) {
      const signalr = await container.getAsync(Signalr);
      await signalr.invoke(ProQaCaseReqMsg, {
        TripUpdateMsg: trip,
        MachineIP: this.workstation,
      });
    },
    async getProQaStatus() {
      if (this.workstation) {
        const signalr = await container.getAsync(Signalr);
        try {
          await signalr.invoke(ProQaRunStatusReqMsg, {
            machineIp: this.workstation,
          });
        }
        catch (e) {
          const error = e as Error;
          const logger = container.get(Logger);
          logger.captureException(error, { tags: { updateTrip: 'ProQaRunStatusReqMsg' } });
        }
      }
    },
    updateWorkstation(workstation: string) {
      this.workstation = workstation;
    },
  },

});
